// extracted by mini-css-extract-plugin
export var container = "_i0-1";
export var editor = "_i0-2";
export var resizable = "_i0-3";
export var wrapper = "_i0-0";